// node_modules
import axios, { AxiosError } from "axios";
import { ToastTypeEnum } from "Enums";
// Helpers
import { AxiosHelperSingleton, ToastHelperSingleton } from "Helpers";
// Types
import { TGeneratedHighlightsDTO, TTechnologyHighlightsGroupDTO, TTechnologyHighlightsGroupsDTO } from "Types";

export class TechnologyHighlightsController {
    public async getTechnologyHighlightsGroupsAsync(technologyId: number): Promise<TTechnologyHighlightsGroupsDTO> {
        return (await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/technologies/${technologyId}/highlights`)).data;
    }
 
    public async createTechnologyHighlightsGroupAsync(caseId: number, technologyHighlightsGroupName: string): Promise<TTechnologyHighlightsGroupDTO | null> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("caseTechnologyHighlightsGroupName", technologyHighlightsGroupName);

        try {
            return (await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/CreateCaseTechnologyHighlightsGroup?isDeliveryAdded=${true}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }

                }
            )).data;
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing these groups.");
                    return null;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to create highlights group.");
            return null;
        }
    }

    public async deleteTechnologyHighlightsGroupAsync(caseId: number, technologyHighlightsGroupId: number, fromTechnologyId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);
        formData.append("fromTechnologyId", `${fromTechnologyId}`);

        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/DeleteCaseTechnologyHighlightsGroup`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }

                });
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to increase significance of technology highlight.");
            return;
        }
    }

    public async moveTechnologyHighlightsGroupForwardAsync(caseId: number, technologyId: number, technologyHighlightsGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);

        await axios.post(
            `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/MoveCaseTechnologyHighlightsGroupForward`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }

            });
    }

    public async moveTechnologyHighlightsGroupBackwardsAsync(caseId: number, technologyId: number, technologyHighlightsGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);

        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/MoveCaseTechnologyHighlightsGroupBackwards`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }

                });
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to increase significance of technology highlight.");
            return;
        }
    }
    
    public async editTechnologyHighlightsGroupNameAsync(caseId: number, technologyHighlightsGroupId: number, newTechnologyHighlightsGroupName: string, fromTechnologyId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);
        formData.append("newCaseTechnologyHighlightsGroupName", `${newTechnologyHighlightsGroupName}`);
        formData.append("fromTechnologyId", `${fromTechnologyId}`);

        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/EditCaseTechnologyHighlightsGroupName`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to increase significance of technology highlight.");
            return;
        }
    }

    public async editTechnologyHighlightDescriptionAsync(caseId: number, technologyHighlightId: number, newTechnologyHighlightDescription: string, fromTechnologyId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyHighlightId", `${technologyHighlightId}`);
        formData.append("newTechnologyHighlightDescription", newTechnologyHighlightDescription);
        formData.append("fromTechnologyId", `${fromTechnologyId}`);

        await axios.post(
            `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/EditTechnologyHighlightDescription`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
    }

    public async increaseSignificanceOfTechnologyHighlightAsync(caseId: number, technologyId: number, technologyHighlightId: number, technologyHighlightGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightId", `${technologyHighlightId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightGroupId}`);
        
        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/IncreaseSignificanceOfTechnologyHighlight`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to increase significance of technology highlight.");
            return;
        }
    }

    public async decreaseSignificanceOfTechnologyHighlightAsync(caseId: number, technologyId: number, technologyHighlightId: number, technologyHighlightGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightId", `${technologyHighlightId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightGroupId}`);

        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/DecreaseSignificanceOfTechnologyHighlight`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to decrease significance of technology highlight.");
            return;
        }
    }

    public async removeTechnologyHighlightFromTechnologyHighlightsGroupAsync(caseId: number, technologyId: number, technologyHighlightId: number, technologyHighlightGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightId", `${technologyHighlightId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightGroupId}`);

        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/RemoveTechnologyHighlightFromCaseTechnologyHighlightsGroup`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to remove highlight from the group.");
            return;
        }
    }

    public async createTechnologyHighlightAsync(caseId: number, technologyId: number, technologyHighlightsGroupId: number,
            technologyHighlightDescription: string, isDeliveryAdded: boolean, documentId: string | undefined = undefined): Promise<boolean> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightDescription", technologyHighlightDescription);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);
        formData.append("isDeliveryAdded", `${isDeliveryAdded}`);
        if (documentId) { formData.append("documentNumber", documentId); }
        
        try {
            return (await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/CreateTechnologyHighlight`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            )).status === 200;
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return false;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to create highlight.");
            return false;
        }
    }

    public async swapTwoTechnologyHighlightsAsync(caseId: number, technologyId: number, technologyHighlightIdA: number,
        technologyHighlightIdB: number, technologyHighlightsGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightIdA", `${technologyHighlightIdA}`);
        formData.append("technologyHighlightIdB", `${technologyHighlightIdB}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);
        
        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/SwapTwoTechnologyHighlights`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to swap highlights.");
            return;
        }
    }

    public async deleteTechnologyHighlightAsync(caseId: number, technologyId: number, technologyHighlightId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightId", `${technologyHighlightId}`);

        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/DeleteTechnologyHighlight?isDeliveryAdded=true`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to add highlight to the group.");
            return;
        }
    }

    public async addTechnologyHighlightToTechnologyHighlightsGroupAsync(caseId: number, technologyId: number, technologyHighlightId: number,
            technologyHighlightsGroupId: number): Promise<void> {
        const formData = new FormData();
        formData.append("caseId", `${caseId}`);
        formData.append("technologyId", `${technologyId}`);
        formData.append("technologyHighlightId", `${technologyHighlightId}`);
        formData.append("caseTechnologyHighlightsGroupId", `${technologyHighlightsGroupId}`);
        
        try {
            await axios.post(
                `${AxiosHelperSingleton.getServerBaseURL()}TechnologyHighlights/AddTechnologyHighlightToCaseTechnologyHighlightsGroup`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
        } catch(error: any) {
            if (axios.isAxiosError(error))  {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this group.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to add highlight to the group.");
            return;
        }
    }

    public async generateTechnologyHighlights(technologyId: number, dataType: string): Promise<TGeneratedHighlightsDTO> {
        const results = await axios.get<TGeneratedHighlightsDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/technology/` + 
            `${technologyId}highlights/generate?dataType=${dataType}`);
        return results.data;
    }
}

export const TechnologyHighlightsControllerSingleton = new TechnologyHighlightsController();